import { createLogicMiddleware } from 'redux-logic';
import { reducer } from './reducer';
import arrLogic from './authentication/logic';
import { applyMiddleware, createStore, compose } from 'redux';
import Axios from 'axios';

const deps = {
  httpClient: Axios
};

const logicMiddleware = createLogicMiddleware(arrLogic, deps);

const middleware = compose(applyMiddleware(logicMiddleware), window.__REDUX_DEVTOOLS_EXTENSION__
  ? window.__REDUX_DEVTOOLS_EXTENSION__()
  : f => f);

const enhancer = middleware;

export const store = createStore(reducer, enhancer);